import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
	Container,
	Card,
	CardBody,
	Row,
	Col,
	CardText,
	Label,
} from "reactstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import {
	AvForm,
	AvField,
	AvCheckbox,
	AvCheckboxGroup,
	AvRadio,
	AvRadioGroup,
} from "availity-reactstrap-validation";
import FileUpload from "components/Common/file-upload/file-upload.component";
import { adminPrefix } from "configs/routePrefix";
import { toast } from "react-toastify";
import CancelModal from "components/CancelModal";
import DeveloperService from "services/Admin/DeveloperService";
import ActivitiesService from "services/Admin/ActivitiesService";
import Select from "react-select";
import { SuccessOk, SuccessCreated } from "configs/statusCode";
import AreasServices from "services/Admin/AreasService";
import CompoundService from "services/Admin/CompoundService";
import SelectOptions from "components/SelectOptions";
import SalesRepsService from "services/Admin/SalesRepsService";
import SuccessModal from "components/SucessModal";

const initialState = {
	email: "",
	compound_ids: [],
	area_ids: [],
	name: "",
	phone: "",
};

const UpdateDeveloperPage = (props) => {
	const [compoundOptions, setCompoundOptions] = useState([]);
	const [formState, setFormState] = useState(initialState);
	const [modal, setModal] = useState(false);
	const [areasOptions, setAreasOptions] = useState([]);
	const [submitAction, setSubmitAction] = useState(false);
	const salesRepsService = new SalesRepsService();
	const [loading, setLoading] = useState(false);
	const [editData, setEditData] = useState(null);
	const [successModal, setSuccessModal] = useState(false);

	const id = props.match.params.id;

	useEffect(() => {
		if (id) {
			salesRepsService.find(id).then((response) => {
				if (response && response.status === SuccessOk) {
					setEditData({ ...response.data });
					// let compunds = response.data.compounds.filter((obj, index, arr) => {
					//     return index === arr.findIndex((o) => o.id === obj.id);
					//   });
					setFormState({
						name: response.data.name.en,
						phone: response.data.phone,
						email: response.data.email,
						compound_ids: response.data.compounds?.map((item) => ({
							label: item.name.en,
							value: item.id,
						})),
						area_ids: response.data.areas.map((item) => ({
							label: item.name.en,
							value: item.id,
						})),
					});
				}
			});
		}
	}, [id]);
	const handleValidSubmit = (e, v) => {
		setLoading(true);
		if (!formState?.phone && id) {
			setSubmitAction(true);
			setLoading(false);
			return;
		}
		let data = {
			name: { en: formState.name },
			email: formState.email,
			compound_ids: formState.compound_ids.map((item) => item.value),
			area_ids: formState.area_ids.map((item) => item.value),
			phone: formState?.phone,
		};
		if (id) {
			salesRepsService
				.update(id, data)
				.then((response) => {
					if (response && response.status === SuccessOk) {
						setSuccessModal(true);
						setLoading(false);
					} else {
						setLoading(false);
						toast.error(response);
					}
					setSubmitAction(false);
				})
				.catch(() => setLoading(false));
		} else {
			salesRepsService
				.inviteSalesRep(data)
				.then((response) => {
					if (response && response.status === SuccessOk) {
						setSuccessModal(true);
						setLoading(false);
					} else {
						setLoading(false);
						toast.error(response);
					}
					setSubmitAction(false);
				})
				.catch(() => setLoading(false));
		}
	};

	const handleFieldChange = (e) => {
		setFormState({ ...formState, [e.target.name]: e.target.value });
	};

	return (
		<React.Fragment>
			<div className="page-content">
				<MetaTags>
					<title>{id ? "Edit Sales Rep" : "Invite Sales Rep"}</title>
				</MetaTags>
				<Container fluid>
					<h4>{id ? "Edit Sales Rep" : "Invite Sales Rep"}</h4>
					<AvForm
						className="form-horizontal min-h-75vh"
						onValidSubmit={(e, v) => {
							handleValidSubmit(e, v);
						}}>
						<Card className="w-100 mt-4">
							<CardBody>
								<Row className="mb-4">
									<Col md={6}>
										<AvField
											label="Email*"
											name="email"
											className="form-control mb-3"
											placeholder="Type Email Address"
											type="email"
											value={formState.email}
											required
											errorMessage="This field is required"
											bsSize="lg"
											onChange={(e) => {
												setSubmitAction(false);
												setFormState({ ...formState, email: e.target.value });
											}}
										/>
									</Col>
									{id ? (
										<Col md={6}>
											<AvField
												label="Sales Rep Name*"
												name="name"
												className="form-control mb-3"
												placeholder="Type Sales Rep Name"
												type="text"
												value={formState.name}
												required
												errorMessage="This field is required"
												bsSize="lg"
												onChange={(e) => {
													setSubmitAction(false);
													setFormState({ ...formState, name: e.target.value });
												}}
											/>
										</Col>
									) : null}
									{id ? (
										<Col md={6}>
											<label className={submitAction ? "text-danger" : ""}>
												Phone*
											</label>
											{/* <AvField
												name="phone"
												placeholder={"0123456789"}
												label="Phone"
												value={formState.phone}
												className="form-control mb-3"
												onChange={(e) => {
													setFormState({ ...formState, phone: e.target.value });
												}}
												bsSize="lg"
												type="number"
											/> */}
											<PhoneInput
												country={"eg"}
												enableSearch={true}
												name="phone"
												style={{
													border: submitAction ? "1px solid red" : "none",
													borderRadius: submitAction ? "5px" : "0",
												}}
												className="rounded-pil phone"
												value={formState.phone}
												onChange={(e) => {
													setSubmitAction(false);
													setFormState({ ...formState, phone: e });
												}}
											/>
											{submitAction && (
												<span
													className="text-danger"
													style={{ fontSize: "10px" }}>
													The phone field is required.
												</span>
											)}
										</Col>
									) : null}
									<Col md={6}>
										<SelectOptions
											label="Compound"
											placeholder="Select"
											options={compoundOptions}
											handleSelectChange={(data) => {
												setSubmitAction(false);
												setFormState({ ...formState, compound_ids: data });
											}}
											selectedOption={formState.compound_ids}
											Service={CompoundService}
											setOptions={(options) => {
												setCompoundOptions(options);
											}}
											isMulti={true}
										/>
									</Col>
									<Col md={6}>
										<SelectOptions
											label="Location"
											placeholder="Select"
											options={areasOptions}
											handleSelectChange={(data) => {
												setSubmitAction(false);
												setFormState({ ...formState, area_ids: data });
											}}
											selectedOption={formState.area_ids}
											Service={AreasServices}
											setOptions={(options) => {
												setAreasOptions(options);
											}}
											isMulti={true}
										/>
									</Col>
								</Row>
							</CardBody>
						</Card>
						<Row className="d-flex justify-content-between pb-4">
							<Col>
								<button
									type="button"
									className="btn btnUpload btnHeight px-4"
									onClick={() => {
										setModal(true);
									}}
									size={"lg"}>
									Cancel
								</button>
							</Col>
							<Col>
								<button
									type="submit"
									className="btn btn-success btnHeight px-4 float-end"
									size={"lg"}
									disabled={loading ? true : false}>
									Submit
								</button>
							</Col>
						</Row>
						<CancelModal
							modal={modal}
							setModal={setModal}
							goBackHandler={() =>
								props.history.push(`${adminPrefix}/sales-rep`)
							}
						/>
						<SuccessModal
							title={id ? "Edit Sales Rep" : "Add New Sales Rep"}
							modal={successModal}
							message={
								id
									? "Sales Rep Edited Successfully"
									: "New Sales Rep Added Successfully"
							}
							onClick={() => props.history.goBack()}
						/>
					</AvForm>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default UpdateDeveloperPage;
